import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CardTermsBlock from '../../../../components/CardTermsBlock';
import Checkbox from '../../../../components/Checkbox';
import ViewportAttachedButton from '../../../../components/ViewportAttachedButton';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import { resetCardCreationDetails, updateCardCreationDetails } from '../../../../store/slices/card/card';

import './OpenCardTerms.scss';

const { routes } = AppConfig;

const OpenCardTerms = () => {
	const dispatch = useDispatch();
	const { confirmTerms = false, consentPersonalData = false } = useSelector(state => state.card.cardCreationDetails);

	const navigate = useNavigate();

	useEffect(() => {
		dispatch(resetCardCreationDetails());
	}, []);

	const updateConfirm = e => {
		dispatch(
			updateCardCreationDetails({
				confirmTerms: e.target.checked,
			})
		);
	};

	const updateConsent = e => {
		dispatch(
			updateCardCreationDetails({
				consentPersonalData: e.target.checked,
			})
		);
	};

	const onContinue = () => {
		navigate(routes.chooseCardColor);
		console.log('Go to next page!');
	};

	return (
		<div className='OpenCardTerms'>
			<div className='OpenCardTerms__body'>
				<CardTermsBlock />
				<Checkbox
					className='OpenCardTerms__confirm'
					checked={confirmTerms}
					label='I confirm that I have read and agree to the Terms of Use and Privacy Policy'
					onChange={updateConfirm}
					disabled={false}
				/>
				<Checkbox
					className='OpenCardTerms__consent'
					checked={consentPersonalData}
					label='I consent to processing of my personal data for account an card services in accordance with the Privacy Policy'
					onChange={updateConsent}
					disabled={false}
				/>
			</div>

			<ViewportAttachedButton
				className='OpenCardTerms__continue'
				onClick={onContinue}
				disabled={!confirmTerms || !consentPersonalData}
			>
				{t('Continue')}
			</ViewportAttachedButton>
		</div>
	);
};

export default OpenCardTerms;
